import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateOutput(node, nodeFields, accept) {
    const { idField, nodeTypeField, outputField } = nodeFields;
    // nodeInput is only for action nodes
    if (nodeTypeField?.nodeType?.value !== 'A')
        return;
    if (outputField?.output.length === 0) {
        accept('error', "Missing required 'output' field for this node.", {
            node: node,
            data: {
                id: idField?.id?.value,
                nodeNumber: node?.name,
                propertyName: FRONTEND_PROPERTY_NAME.OUTPUT,
            },
        });
    }
}
//# sourceMappingURL=validate-output.js.map